<template>
  <div class="login-warp">
    <top-nav-menu>
      <div class="nav-list" style="height: 90px; line-height: 90px">
        <template v-for="item in menuList">
          <router-link
            v-if="item.target === 'self'"
            :class="['menu-item']"
            :key="item.name"
            :to="item.path"
            >{{ item.name }}</router-link
          >
          <a
            class="menu-item"
            v-else-if="item.target === 'blank'"
            :href="item.path"
            target="_blank"
            :key="item.name"
            >{{ item.name }}</a
          >
        </template>
      </div>
    </top-nav-menu>
    <slot></slot>
    <div class="foot-nav">
      <div class="foot-nav-warp">
        <a
          class="link"
          v-for="item in navList"
          :href="item.path"
          target="_blank"
          :key="item.name"
          >{{ item.name }}</a
        >
      </div>
    </div>
    <div class="foot-bar">
      <div class="foot-bar-warp">
        <div class="foot-section1">
          <div class="foot-section-text">
            长春市智绘网络科技有限公司 <a href="http://beian.miit.gov.cn" target="_blank" style="color:#7c7cae;">吉ICP备2020005562号-1</a>
          </div>
          <div class="foot-section-text">
            长春市绿园区皓月大路739号（西郊路23号）标记大厦二单元1003号房
          </div>
          <div class="foot-section-text">
          			吉林省通信管理局认证域名注册服务机构 <a href="https://domain.miit.gov.cn/域名注册服务机构/互联网域名/长春市智绘网络科技有限公司"
          			rel="nofollow" target="_blank" style="color:#7c7cae;">点此查看批文</a>
          </div>
        </div>
        <div class="foot-section2">
          <div class="foot-section-text">客服、投诉电话：400-018-6863 邮编：341000</div>
          <div class="foot-section-text">客服、投诉邮箱：domain_service@hhzh.net</div>
          <div class="foot-section-text">
            <a  href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=22010602000638" target="_blank" class="flx-row-c">
              <img class="beian" :src="record">
              <span class="foot-section-text text">吉公网安备22010602000638号</span>
            </a>
          </div>
        </div>
        <div class="foot-section3">
          <div class="foot-section-text">
            国家域名注册服务投诉中心投诉
          </div>
          <div class="foot-section-text">
            受理电话:010-58813000
          </div>
          <div class="foot-section-text">
            受理邮箱:service@cnnic.cn
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import topNavMenu from "components/topNavMenu";

export default {
  name: "layout",
  components: {
    topNavMenu,
  },
  data() {
    return {
      record: require("@/assets/image/record.png"),
      menuList: [
        {
          name: "域名注册",
          path: "/index",
          target: "self",
        },
        {
          name: "招聘职位",
          path: "http://www.hhzh.net/job.aspx?nid=11",
          target: "blank",
        },
        {
          name: "关于我们",
          path: "http://www.hhzh.net/about_complex.aspx?nid=1",
          target: "blank",
        },
        {
          name: "联系我们",
          path: "http://www.hhzh.net/contact_complex.aspx?nid=7",
          target: "blank",
        },
      ],
      navList: [
        {
          name: "招聘职位",
          path: "http://www.hhzh.net/job.aspx?nid=11",
          target: "blank",
        },
        {
          name: "关于我们",
          path: "http://www.hhzh.net/about_complex.aspx?nid=1",
          target: "blank",
        },
        {
          name: "联系我们",
          path: "http://www.hhzh.net/contact_complex.aspx?nid=7",
          target: "blank",
        },
      ],
    };
  },
};
</script>
<style lang="less" scoped>
.login-warp {
  position: relative;
  background-size: cover;
  background-position: top center;
  background-repeat: no-repeat;
  min-height: 100vh;
  .menu-item {
    color: #fff;
    line-height: 60px;
    font-weight: 400;
    font-size: 14px;
    margin-right: 40px;
  }
}
.foot-nav {
  display: flex;
  align-items: center;
  background-color: #222b5a;
  height: 156px;
  .foot-nav-warp {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    .link {
      width: 120px;
      height: 45px;
      line-height: 45px;
      border-radius: 23px;
      border: 1px solid #ffffff1a;
      text-align: center;
      font-size: 14px;
      color: #cacaff;
      font-weight: 400;
    }
    .link.active {
      color: #fff;
      background-color: #3992e9;
      border-color: #3992e9;
    }
  }
}
.foot-bar {
  background-color: #222b5a;
  border-top: 1px solid #ffffff1a;
  .foot-bar-warp {
    width: 1300px;
    margin: 0 auto;
    display: flex;
    padding-top: 65px;
    padding-bottom: 76px;
    .foot-section-text {
      font-weight: 400;
      font-size: 14px;
      color: #7c7cae;
      &:nth-child(n + 2) {
        margin-top: 25px;
      }
    }
    .foot-section1 {
      flex: 2.5
    }
    .foot-section2 {
      margin-left: 20px;
      flex: 2.5;
      .flx-row-c{
        height: 20px;
        display: flex;
        align-items: center;
      }
      .text{
        margin-top:-1px;
        margin-left: 5px;
      }
    }
     .foot-section3{
     flex: 1.5;
      margin-left: 20px;
      .flx-row-c{
        height: 20px;
        display: flex;
        align-items: center;
      }
      .text{
        margin-top:-1px;
        margin-left: 5px;
      }
    }
  }
}
.nav-list {
  position: relative;
  &::before {
    content: "";
    display: inline-block;
    position: absolute;
    width: 20px;
    height: 3px;
    background-color: #fff;
    bottom: 0;
    left: 20px;
  }
}
</style>
